(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-native-contact-page]').forEach(root => {
      if (root.dataset.nativeContactReady) return;
      root.dataset.nativeContactReady = 'true';
      const groups = Array.from(root.querySelectorAll('[data-native-kind="Accordion"]'));
      groups.forEach(group => {
        const headers = Array.from(group.querySelectorAll('[data-native-kind="Accordion.Header"]'))
          .filter(button => button.closest('[data-native-kind="Accordion"]') === group);
        const panelFor = button => Array.from(group.querySelectorAll('[data-native-kind="Accordion.Content"]'))
          .find(panel => panel.dataset.id === button.dataset.headerId);
        const setExpanded = (button, expanded, animate) => {
          const panel = panelFor(button);
          if (!panel) return;
          panel.getAnimations().forEach(animation => animation.cancel());
          const fromHeight = panel.getBoundingClientRect().height;
          button.dataset.active = String(expanded);
          button.setAttribute('aria-expanded', String(expanded));
          const icon = button.querySelector('.nic-56fb00bc035d, .nic-861fb0acfe4e');
          if (icon) {
            icon.classList.toggle('nic-56fb00bc035d', !expanded);
            icon.classList.toggle('nic-861fb0acfe4e', expanded);
          }
          panel.style.display = expanded ? 'block' : 'none';
          if (!animate || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const toHeight = expanded ? panel.scrollHeight : 0;
          if (!fromHeight && !toHeight) return;
          panel.style.display = 'block';
          panel.style.overflow = 'hidden';
          const animation = panel.animate([
            { height: `${fromHeight}px`, opacity: expanded ? 0 : 1 },
            { height: `${toHeight}px`, opacity: expanded ? 1 : 0 }
          ], { duration: 350, easing: 'ease' });
          animation.onfinish = () => {
            panel.style.display = expanded ? 'block' : 'none';
            panel.style.removeProperty('overflow');
          };
        };
        headers.forEach(button => {
          setExpanded(button, button.dataset.active === 'true', false);
          button.addEventListener('click', () => {
            const expanded = button.dataset.active !== 'true';
            if (expanded && group.dataset.multiple !== 'true') {
              headers.filter(other => other !== button && other.dataset.active === 'true')
                .forEach(other => setExpanded(other, false, true));
            }
            setExpanded(button, expanded, true);
          });
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
